import React from 'react';
import { Row, Col, Alert } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Draggable from 'react-draggable';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Timeout } from './utils/Common';
import { FetchData } from './utils/DataFetch';
import './login.css';

export class UserChangePasswordForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current_password: '',
            new_password: '',
            confirm_password: '',
            currentPasswordVisible: false,
            newPasswordVisible: false,
            confirmPasswordVisible: false,
            passwordChangeModal: this.props.passwordChangeModal,
            alert: {
                color: "info",
                message: "",
                isOpen: false
            },
            deltaPosition: { x: 0, y: 0 },
        };
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
        this.setCurrentPasswordVisible = this.setCurrentPasswordVisible.bind(this);
        this.setNewPasswordVisible = this.setNewPasswordVisible.bind(this);
        this.setConfirmPasswordVisible = this.setConfirmPasswordVisible.bind(this);
        this.keydownHandler = this.keydownHandler.bind(this);
    }

    componentDidMount() {
        this.setState({ isMounted: true }); // Set isMounted to true when the component mounts
        document.addEventListener('keydown', this.keydownHandler);
        return () => {
            document.removeEventListener('keydown', this.keydownHandler);
        };
    }

    componentWillUnmount() {
        this.setState({ isMounted: false }); // Set isMounted to false when the component unmounts
        document.removeEventListener('keydown', this.keydownHandler);
    }

    onStart = () => {};

    onStop = () => {};

    handleDrag = (e, ui) => {
        const { deltaPosition = { x: 0, y: 0 } } = this.state || {};
        this.setState({
            deltaPosition: {
                x: deltaPosition.x + ui.deltaX,
                y: deltaPosition.y + ui.deltaY,
            },
        });
    };

    async keydownHandler(e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            this.handleSubmit();
        }
        if (e.keyCode === 27) {
            e.preventDefault();
            this.handleCancel();
        }
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    async handleSubmit() {
        if (this.state.new_password !== this.state.confirm_password) {
            this.handleSaveEventSuccess({
                message: "Passwords do not match",
                color: "warning"
            });
            return;
        } else {
            const data = {
                Username: this.props.user.email,
                CurrentPassword: this.state.current_password,
                NewPassword: this.state.new_password
            };

            try {
                const response = await FetchData("/changepassword", "POST", this.props.user.token, data);

                if (response.message === "Password changed successfully") {
                    this.handleSaveEventSuccess({
                        message: "Password changed successfully",
                        color: "success"
                    });
                    this.setState({ current_password: '', new_password: '', confirm_password: '' });
                    this.props.setPasswordChangeModal(false);
                } else {
                    this.handleSaveEventSuccess({
                        message: response.message,
                        color: "warning"
                    })
                }

            } catch (error) {
                return;
            }

        }
    }

    handleSaveEventSuccess(alert) {
        this.setState({
            alert: {
                color: alert.color,
                message: alert.message,
                isOpen: true
            }
        }, () => {
            window.setTimeout(() => {
                this.setState({ alert: { isOpen: false } });
            }, Timeout(alert.message));
        });
    }

    handleCancel() {
        this.props.setPasswordChangeModal(false);
    }

    setCurrentPasswordVisible(currentPasswordVisible) {
        this.setState({ currentPasswordVisible });
    }

    setNewPasswordVisible(newPasswordVisible) {
        this.setState({ newPasswordVisible });
    }

    setConfirmPasswordVisible(confirmPasswordVisible) {
        this.setState({ confirmPasswordVisible });
    }

    render() {
        const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
        const { deltaPosition = { x: 0, y: 0 } } = this.state || {};

        return (
            <Draggable
                handle=".user-change-password-handle"
                onDrag={this.handleDrag}
                {...dragHandlers}
            >
                <Modal
                    isOpen={this.props.passwordChangeModal}
                    toggle={this.props.setPasswordChangeModal}
                    style={{
                        transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
                        width: "500px",
                        height: "300px"
                    }}
                    backdrop="static"
                >
                    <ModalHeader
                        className="user-change-password-handle handle"
                        style={{ textAlign: 'center', display: 'block', width: '100%' }}
                    >
                        Reset Password
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col style={{ textAlign: 'center' }}>
                                <Alert color={this.state.alert.color} isOpen={this.state.alert.isOpen} >
                                    {this.state.alert.message}
                                </Alert>
                            </Col>
                        </Row>

                        <p>Password Reset</p>

                        <div className="form-group">
                            <label htmlFor="current_password">Current Password</label>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type={this.state.currentPasswordVisible ? "text" : "password"}
                                    name="current_password"
                                    className="form-control"
                                    id="current_password"
                                    value={this.state.current_password}
                                    onChange={this.handleChange}
                                    placeholder="Enter your current password"
                                    autoComplete="off"
                                    style={{ paddingRight: '2.5rem' }} // Add padding to the right to make space for the icon
                                />
                                <span
                                    className="password-toggle-icon"
                                    onClick={() => this.setCurrentPasswordVisible(!this.state.currentPasswordVisible)}
                                    style={{
                                        position: 'absolute',
                                        right: '0.5rem',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {this.state.currentPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="new_password">New Password</label>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type={this.state.newPasswordVisible ? "text" : "password"}
                                    name="new_password"
                                    className="form-control"
                                    id="new_password"
                                    value={this.state.new_password}
                                    onChange={this.handleChange}
                                    placeholder="Enter your new password"
                                    autoComplete="off"
                                    style={{ paddingRight: '2.5rem' }} // Add padding to the right to make space for the icon
                                />
                                <span
                                    className="password-toggle-icon"
                                    onClick={() => this.setNewPasswordVisible(!this.state.newPasswordVisible)}
                                    style={{
                                        position: 'absolute',
                                        right: '0.5rem',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {this.state.newPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="confirm_password">Confirm Password</label>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type={this.state.confirmPasswordVisible ? "text" : "password"}
                                    name="confirm_password"
                                    className="form-control"
                                    id="confirm_password"
                                    value={this.state.confirm_password}
                                    onChange={this.handleChange}
                                    placeholder="Confirm your new password"
                                    autoComplete="off"
                                    style={{ paddingRight: '2.5rem' }} // Add padding to the right to make space for the icon
                                />
                                <span
                                    className="password-toggle-icon"
                                    onClick={() => this.setConfirmPasswordVisible(!this.state.confirmPasswordVisible)}
                                    style={{
                                        position: 'absolute',
                                        right: '0.5rem',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {this.state.confirmPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-primary" onClick={this.handleSubmit}>Submit</button>
                        <button type="button" className="btn btn-default" onClick={this.handleCancel}>Cancel</button>
                    </ModalFooter>
                </Modal>
            </Draggable>
        );
    }
}
